import { createEntityAdapter } from "@ngrx/entity";
import { Article } from "../../api/models/article.model";

export const articlesAdapter = createEntityAdapter<Article>();